import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';

interface Props extends FieldRenderProps<string> {
  items: RadioItem[];
  size: 'small' | 'medium';
}

export interface RadioItem {
  value: string;
  label: string;
  color?: 'primary' | 'secondary';
}

const RadioGroupAdapter = ({
  input: { value, name, onChange },
  size = 'small',
  items = [],
  label = '',
  ...rest
}: Props) => (
  <FormControl>
    {label && <FormLabel>{label}</FormLabel>}
    <RadioGroup {...rest} name={name} value={value} onChange={onChange}>
      {items.map((v) => (
        <FormControlLabel
          key={`radio_${name}_${v.value}`}
          value={v.value}
          control={<Radio size={size} color={v.color || 'primary'} />}
          label={v.label}
        />
      ))}
    </RadioGroup>
  </FormControl>
);

export default RadioGroupAdapter;
